import React from 'react';
import { Radio } from 'antd';
import PropTypes from 'prop-types';
import { Label, InfoMessage } from 'components';

const RadioGroup = ({ options, label, disabled, bold, labelBold, asterisk=false, infoMessage, iconClassName, infoMessageClassName, ...rest }) => {
  return (
    <div className="custom-radio-group">
      <div className={`d-flex mb-1 ${labelBold ? 'text-bold' : ''}`} >
        <Label label={label} bold={bold} asterisk={asterisk}/>
        <InfoMessage
          infoMessage={infoMessage}
          overlayClassName={infoMessageClassName}
          iconClassName={iconClassName}
        />
      </div>      
      <Radio.Group {...rest}>
        {options.map(({ label, value }, index) => (
          <Radio key={index} value={value} disabled={disabled ? disabled : options[index].disabled}>
            {label}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
};

RadioGroup.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default RadioGroup;
